import {
  Heart,
  Repeat,
  Baby,
  Sparkles,
  Users,
  Network,
} from "lucide-react";
import Reveal from "@/components/site/Reveal";

const list = [
  "des blessures émotionnelles anciennes",
  "des schémas répétitifs",
  "des vécus difficiles ou non intégrés",
  "des loyautés invisibles",
  "des dynamiques familiales lourdes",
  "des blessures prénatales ou transgénérationnelles",
];

const grid = [
  { icon: Heart, title: "Psychotraumas", desc: "Travail ciblé sur les blessures profondes." },
  { icon: Repeat, title: "Schémas émotionnels", desc: "Identifier les boucles qui se rejouent." },
  { icon: Baby, title: "Enfant intérieur", desc: "Reconnexion à ce qui a été déposé tôt." },
  { icon: Sparkles, title: "Mémoires prénatales", desc: "Explorer les empreintes les plus précoces." },
  { icon: Users, title: "Histoire familiale", desc: "Lire les fidélités et héritages." },
  { icon: Network, title: "Transgénérationnel", desc: "Mettre au jour ce qui se transmet." },
];

export default function Expertise() {
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
                — Expertise
              </span>
              <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
                Un travail ciblé sur les psychotraumas
              </h2>
            </Reveal>

            <Reveal delay={0.12}>
              <p className="mt-8 text-base text-[#5F6170] leading-relaxed">
                J'accompagne les personnes confrontées à :
              </p>
              <ul className="mt-4 space-y-3">
                {list.map((l, i) => (
                  <li
                    key={l}
                    data-testid={`expertise-list-${i}`}
                    className="flex items-start gap-3 text-[#1E1E2A]"
                  >
                    <span className="mt-2.5 w-1.5 h-1.5 rounded-full bg-[#C98FA3] flex-shrink-0" />
                    <span className="text-base">{l}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {grid.map(({ icon: Icon, title, desc }, i) => (
                <Reveal key={title} delay={i * 0.06}>
                  <div
                    data-testid={`expertise-card-${i}`}
                    className="group h-full p-7 bg-white rounded-3xl border border-[#DDD7E2] shadow-[0_8px_30px_rgb(0,0,0,0.03)] hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(40,71,184,0.08)] hover:border-[#C98FA3] transition-all duration-300"
                  >
                    <div className="w-12 h-12 rounded-full bg-[#F3EEF4] flex items-center justify-center group-hover:bg-[#C98FA3] transition-colors">
                      <Icon className="w-5 h-5 text-[#3A2E6E] group-hover:text-white transition-colors" />
                    </div>
                    <h3 className="font-serif-display text-2xl text-[#1E1E2A] mt-5">{title}</h3>
                    <p className="mt-2 text-sm text-[#5F6170] leading-relaxed">{desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        <Reveal delay={0.2}>
          <p className="mt-20 max-w-4xl mx-auto text-center text-lg md:text-xl text-[#5F6170] font-serif-display italic leading-relaxed">
            Le travail peut inclure l'exploration de l'enfance, la reconnexion à l'enfant intérieur,
            l'identification de blessures anciennes, d'abus ou de mémoires familiales agissantes.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
